<template>
  <div class="widget">
    <div>
      <div class="dataTables_wrapper" ref="dataTables_wrapper">

        <div ref="tableHeader" class="tableHeader">
          <div
            class="dataColumn"
            v-for="(field, key) in dataColumns"
            v-on:click.self="changeSorting(field.key)"
            :key="key"
            :style="{ width: field.width }"
            :class="{ active: field.key == sortBy, hasFilter: !field.filter || field.filter !== 'undefined' }"
          >
            <label :for="field.key">
              {{ field.title }}
              <i
                class="fa"
                v-if="sortBy === field.key"
                :class="{ 'fa-sort-desc': orderBy === 'desc', 'fa-sort-asc': orderBy === 'asc'}"
              ></i>
            </label>
            <div v-if="field.hasFilter != false">
              <template v-if="field.type === 'input'">
                <input
                  type="text"
                  class="form-control"
                  autocomplete="off"
                  :id="field.key"
                  :name="field.key"
                  :ref="field.key"
                  v-model="field.value"
                  @keyup.enter="doFilter()"
                />
              </template>
              <template v-else-if="field.type === 'datepicker'">
                <div class="datepicker">
                  <datePicker
                    v-model="field.value.from"
                    @dp-change="doFilter()"
                    :config="{format: 'D-MMM-YYYY',useCurrent: false, showClear: true, icons: {clear: 'fas fa-times-circle'}}"
                  ></datePicker>
                  <datePicker
                    v-model="field.value.to"
                    @dp-change="doFilter()"
                    :config="{format: 'D-MMM-YYYY',useCurrent: false, showClear: true, icons: {clear: 'fas fa-times-circle'}}"
                  ></datePicker>
                </div>
              </template>
              <template v-else-if="field.type === 'select'">
                <select
                  class="form-control"
                  size
                  :id="field.key"
                  :name="field.key"
                  :ref="field.key"
                  v-model="field.value"
                  @change="doFilter()"
                >
                  <option value selected>-</option>
                  <option
                    :value="item[field.selectOptions.valueKey]"
                    v-for="(item, key) in field.selectOptions.datas"
                    :key="key"
                  >{{ item[field.selectOptions.displayKey] }}</option>
                </select>
              </template>
            </div>
          </div>
        </div>


        

        <div v-if="isLoading" class="text-center">
          <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
        </div>

        <template v-else>

          <div v-if="errors" class="text-center p-3">
            <div>Fail to load the data</div>
            <button class="btn btn-danger m-t-20" type="button" v-on:click="reload()">Reload</button>
          </div>

          <div v-else>
            <div v-if="orderedDatas.length <= 0">
                <md-empty-state
                  md-rounded
                  md-label="Empty"
                  md-description="No data shows at this moment"
                  :md-size="200"
                  style="margin-top: 60px; margin-bottom: 30px;"
                ></md-empty-state>
            </div>

            <!--RecycleScroller
              v-else-if="orderedDatas.length > 0"
              ref="scroller"
              class="scroller"
              :items="orderedDatas"
              :item-size="30"
              :emit-update="true"
              key-field="id"
              v-slot="{ item, index }"
              :style="{ 'max-height': orderedDatas.length != 1 ? '70vh' : '30px' }"
              :class="{ 'usePixel': usePixel }"
            >
              <div 
                class="scroller-row"
                :key="item.id"
                :class="[ {active: item == selectedItem}, [ index % 2 == 0 ? 'odd' : 'even' ] ]"
                :style="customRowStyle(item)"
                v-on:click="selectItem(item, index)"
                v-on:dblclick="dblclickItem($event, item)"
                @contextmenu.prevent="openMenu($event, item)"
              >
                <div
                  v-for="(field, key) in dataColumns"
                  :key="key"
                  :style="{ width: field.width }"
                  class="dataColumn"
                >
                  <div class="displayField" :style="{width: usePixel ? field.width : '100%'}" :title="fieldDisplay(field, item)">
                    {{ fieldDisplay(field, item) }}
                  </div>
                </div>
              </div>
            </RecycleScroller-->

            <virtual-list 
              class="virtual-list" 
              :size="virtualItemSize" 
              :remain="virtualListRemain" 
              ref="virtualList" 
              v-else-if="orderedDatas.length > 0"
              :class="{ 'usePixel': usePixel }"
            >
              <div 
                v-for="(item, key) of orderedDatas"
                class="scroller-row"
                :key="item.id"
                :class="[ {active: item == selectedItem}, [key % 2 == 0 ? 'odd' : 'even']]"
                :style="customRowStyle(item)"
                v-on:click="selectItem(item, key)"
                v-on:dblclick="dblclickItem($event, item)"
                @contextmenu.prevent="openMenu($event, item)"
              >
                <div
                  v-for="(field, key) in dataColumns"
                  :key="key"
                  :style="{ width: field.width }"
                  class="dataColumn"
                >
                  <div class="displayField" :style="{width: usePixel ? field.width : '100%'}" :title="fieldDisplay(field, item)">
                    {{ fieldDisplay(field, item) }}
                  </div>
                </div>
              </div>
            </virtual-list>

          </div>
          
        </template>

        <vue-context ref="menu">
          <ul slot-scope="item">
            <!--li @click="viewItem($event, item.data)" v-if="!excludeButtons.includes('view')">View</li>
            <li @click="editItem($event, item.data)" v-if="!excludeButtons.includes('edit')">Edit</li>
            <li @click="confirmDelete($event, item.data)" v-if="!excludeButtons.includes('delete')">Delete</li-->
            <slot :item="item" name="menuButtons"></slot>
          </ul>
        </vue-context>
      </div>
    </div>

    <!-- Delete Confirm -->
    <md-dialog-confirm
      :md-active.sync="showDeleteConfirmDialog"
      md-title="Confirm Delete"
      md-content="Are you sure delete this record?"
      md-confirm-text="Confirm"
      md-cancel-text="Cancel"
      @md-cancel="cancelDelete"
      @md-confirm="deleteItem"
      ref="modalConfirmDelete"
    />
  </div>
</template>
<script>

//import 'bootstrap/dist/css/bootstrap.css';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import { VueContext } from 'vue-context';
import moment from 'moment';

export default {
  name: 'DataTable',
  components: {
    datePicker,
    VueContext,
  },
  props: {
    startLoading: Boolean,
    width: String,
    settings: Object,

    dataFeed: Object,
    dataPromise: Promise,
    dataHandle: Function,

    dataColumns: Array,
    filterEvent: Function,
    //filteredDatas: Array,

    excludeButtons: {
      default: () => [],
      type: Array
    },

    //datas: Array,
    dataTableHeight: String,

    defaultSortBy: String,

    customSelectItem: Function,
    customUnselectItem: Function,
    customViewItem: Function,
    customEditItem: Function,
    customAfterDeleteEvent: Function,

    hasContextMenu: Function,
    allowView: Function,
    allowEdit: Function,
    allowDelete: Function,

    customRowStyle: {
      type: Function,
      default: () => { }
    },
    customColumnStyle: {
      type: Function,
      default: () => { }
    },

    customFilter: {
      type: Object,
    },

    usePixel: {
      type: Boolean,
      default: false
    }

  },
  watch: {
    page: function (newValue, oldValue) {
      this.previousPage = oldValue
    },
    startLoading: {
      immediate: true,
      handler(start) {
        if (start)
          this.getDatas()
      }
    },
    dataColumns:  {
      immediate: false,
      handler(columns) {
        var totalWidth = 0;
        columns.forEach(column => {
          
          if( column.width.match(/(\d*)px$/) ) {
            totalWidth += column.width.match(/(\d*)px$/)[1] * 1
          } else if( column.width.match(/(\d*)%$/) ) {
            totalWidth += this.$refs.dataTables_wrapper.clientWidth * column.width.match(/(\d*)%$/)[1] / 100
          } else if( column.width.match(/^(\d*)$/) ) {
            totalWidth += column.width.match(/^(\d*)$/)[1] * 1
          }
          
        })

        if( this.$refs.dataTables_wrapper.clientWidth > totalWidth ) {
          columns[columns.length - 1].width = columns[columns.length - 1].width.match(/(\d*)px$/)[1] * 1 + this.$refs.dataTables_wrapper.clientWidth - totalWidth - 15 + 'px'
        }

      }
    }
  },
  computed: {
    virtualListRemain: function() {
      if( this.remain == null )
        return Math.ceil(document.documentElement.clientHeight * 0.7 / this.virtualItemSize)
      else
        return this.remain
    },   
    showDeleteConfirmDialog: {
      get: function () {
        return this.selectedDeleteItem != null
      },
      set: function (e) { }
    },
    orderedDatas: function () {
      if (!this.filteredDatas) return []
      return this.filteredDatas.slice().sort((a, b) => {

        a = a[this.sortBy]
        b = b[this.sortBy]

        let order = this.orderBy === 'asc' ? 1 : -1
        return (a === b ? 0 : a > b ? -1 : 1) * order
      }).slice((this.page - 1) * this.showPerPage, this.page * this.showPerPage)
    },
    showing: function () {
      return { 'from': (this.page - 1) * this.showPerPage + 1, 'to': this.filteredDatas.length > this.page * this.showPerPage ? this.page * this.showPerPage : this.filteredDatas.length }
    },
    totalPage: function () {
      return this.showPerPage >= this.filteredDatas.length ? 1 : Math.ceil(this.filteredDatas.length / this.showPerPage)
    },
    pageLinkShow: function () {
      let pageLink = [];
      if (this.totalPage <= this.maxPageLinkShow) {
        for (var x = 1; x <= this.totalPage; x++) {
          pageLink.push(x)
        }
      } else {
        let startMiddleNum = Math.ceil(this.maxPageLinkShow / 2)
        let endtMiddleNum = Math.ceil(this.totalPage - startMiddleNum + 1)

        if (this.page <= startMiddleNum) {
          for (var x = 1; x <= this.maxPageLinkShow; x++) {
            pageLink.push(x)
          }
        } else if (this.page >= endtMiddleNum) {
          for (var x = endtMiddleNum - 2; x <= this.totalPage; x++) {
            pageLink.push(x)
          }
        } else {
          for (var x = this.page - 2; x <= this.page + 2; x++) {
            pageLink.push(x)
          }
        }
      }

      return pageLink;
    },
    hasButtonSlot() {
      return !!this.$scopedSlots.menuButtons
    }
  },
  data() {
    return {
      isLoading: false,
      errors: null,
      selectedItem: null,
      selectedDeleteItem: null,
      sortBy: null,
      orderBy: null,
      filteredDatas: [],
      maxPageLinkShow: 5,
      showPerPage: 10000000000000,
      showOptions: [5, 10, 25, 50, 100],
      page: 1,
      previousPage: 1,
      checkedAll: [],
      datas: [],

      remain: null,
      defaultRemain: 20,
      virtualItemSize: 30,
    };
  },
  mounted() {

    this.$watch('dataFeed', function (e) {
      this.getDatas()
    })

  },
  updated() {
    this.$nextTick(function () {
      if( this.$refs.virtualList ) {
        this.$refs.virtualList.$el.addEventListener('scroll', event => {
          this.$refs.tableHeader.scrollLeft = this.$refs.virtualList.$el.scrollLeft
        }, false)
      }
    })
  },
  methods: {
    

    openMenu($event, item) {
      this.$refs.menu.close()
      if (typeof this.hasContextMenu !== 'undefined' && this.hasContextMenu(item))
        this.$refs.menu.open($event, item)
    },

    selectItem(item, key) {

      if (this.selectedItem == item) {
        this.selectedItem = null
        if (typeof this.customUnselectItem !== 'undefined') {
          this.customUnselectItem(item, key)
        }
      } else {
        this.selectedItem = item
        if (typeof this.customSelectItem !== 'undefined')
          this.customSelectItem(item, key)
      }
    },

    editItem($event, item) {
      let settings = this.settings
      if (typeof this.customEditItem !== 'undefined') {
        this.customEditItem(item)
      } else {
        this.$router.push({ name: settings.sectionName + '.edit', params: { id: item.id } })
      }
    },

    viewItem($event, item) {
      let settings = this.settings
      if (typeof this.customViewItem !== 'undefined') {
        this.customViewItem(item)
      } else {
        this.$router.push({ name: settings.sectionName + '.view', params: { id: item.id } })
      }
    },

    deleteItem() {

      let settings = this.settings
      let item = this.selectedDeleteItem
      let id = item.id
      if (id)
        this.$http
          .delete(settings.webService + "/" + id)
          .then(res => {
            let index = this.datas.indexOf(item)

            this.datas.splice(index, 1)

            if (typeof this.customAfterDeleteEvent !== 'undefined')
              this.customAfterDeleteEvent()
            else
              this.doFilter()


          })
          .catch((err) => {
            this.alertNotice({
              type: 'danger',
              title: 'Failed',
              content: err.data.message,
            })
            
          })
          .finally(() => {
            this.selectedDeleteItem = null
            this.selectedItem = null
          })
    },

    confirmDelete($event, item) {
      this.selectedDeleteItem = item
    },
    cancelDelete() {
      this.selectedDeleteItem = null
    },

    changeSorting(key) {
      if (this.sortBy == key) {
        this.orderBy = this.orderBy === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortBy = key
        this.orderBy = 'desc'
      }
    },

    doSorting() {
      this.filteredDatas = this.filteredDatas.slice().sort(function (a, b) {
        a = a[this.sortBy]
        b = b[this.sortBy]
        let order = this.orderBy === 'asc' ? 1 : -1
        return (a === b ? 0 : a > b ? 1 : -1) * order
      })
    },



    defaultFilter( customFilter ) {

      this.filteredDatas = this.datas.filter(item => {

        var filtered = true

        this.dataColumns.forEach(element => {
          let searchColumn = element
          let searchValue = searchColumn.value
          let searchColumnType = searchColumn.type
          let itemValue
          if( typeof searchColumn.customItemValue === 'function' )
            itemValue = searchColumn.customItemValue(item)
          else
            itemValue = item[searchColumn.key]

          if (searchValue === null || searchValue === '') return

          if( itemValue === null ) {
            filtered = false
            return 
          }

          if (searchColumnType === 'input') {

            if (
              !itemValue ||
              itemValue === 'undefined' || 
              itemValue.toString().toLowerCase().indexOf(searchValue.toString().toLowerCase()) == -1)
                filtered = false

          } else if (searchColumnType === 'datepicker') {

            if( !moment(itemValue).isValid() )
              console.log()
            else if (
              !itemValue ||
              itemValue === 'undefined' ||
              ( searchValue.from && moment(searchValue.from).format('X') > moment(itemValue).format('X') ) ||
              ( searchValue.to  && moment(searchValue.to).format('X') < moment(itemValue).format('X') )
            )
              filtered = false

          } else if (searchColumnType === 'select') {

            let searchKey = searchColumn.selectOptions.searchKey
            let isBySpecificKey = typeof searchKey !== 'undefined' ? true : false

            if (itemValue === 'undefined' || (!isBySpecificKey && item[searchColumn.key] != searchValue) || (isBySpecificKey && item[searchColumn.key][searchKey] != searchValue))
              filtered = false
          }

          

        })

        if( typeof this.customFilter !== 'undefined' && this.customFilter ) {
          if( this.customFilter.filter(item) === false )
            filtered = false
        }

        return filtered
        
      })

      if(this.$refs.virtualList)
        this.$refs.virtualList.forceRender()

    },

    doFilter() {
      if (typeof filterEvent !== 'undefined') {
        this.filterEvent()
      } else {
        this.defaultFilter()
      }
    },

    async getDatas() {

      this.loading()

      try {
        let res = await this.$http({
          method: this.dataFeed.method,
          url: this.dataFeed.url,
          data: this.dataFeed.data,
        })

        this.datas = this.dataHandle(res)
        this.doFilter()
        if (typeof this.defaultSortBy !== 'undefined')
          this.changeSorting(this.defaultSortBy)

      } catch ( err ) {
        this.datas = []
        this.doFilter()
        this.error(err)
      }



      this.finally()

    },

    fieldDisplay(field, item) {

      if( typeof field.customValueDisplay === 'function' ) {
        return field.customValueDisplay(item)
      } else if ( typeof field.itemDisplayKey !== 'undefined' ) {
        return typeof field.datafilter === 'function' ? field.datafilter(item[field.key][field.itemDisplayKey]) : item[field.key][field.itemDisplayKey]
      } else {
        return typeof field.datafilter === 'function' ? field.datafilter(item[field.key]) : item[field.key]
      }

    },

    async reset() {

      this.loading()

      let res = await this.$http({
        method: this.dataFeed.method,
        url: this.dataFeed.url,
        data: this.dataFeed.data,
      })

      
      let datas = this.dataHandle(res)

      if( this.selectedItem ) {
        let matchedItem = datas.find(i => i.id == this.selectedItem.id)
        if(matchedItem) {
          this.filteredDatas = [datas.find(i => i.id == this.selectedItem.id)]
          this.selectedItem = matchedItem
        }

        this.datas = datas
        //this.doFilter()

      } else {
        this.datas = datas
        this.doFilter()
        if (typeof this.defaultSortBy !== 'undefined')
          this.changeSorting(this.defaultSortBy)
      }

      this.finally()

    },
    reload() {
      this.selectedItem = null
      this.getDatas()
    },
    loading() {
      this.isLoading = true
      this.errors = null
    },
    finish() { },
    error(err) {
      console.log(err)
      this.errors = true
    },
    finally() {
      this.isLoading = false;
    },
  }
}
</script>
<style>
.hide { display: none; }

.displayField { overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
.scroller { font-size: 11px; overflow-x: auto;}
.scroller-row { height: 30px; cursor: pointer; white-space: nowrap; display: inline-flex; width: 100%; border-top: 1px solid #cccbcb; box-shadow: 0 1px 0 #fafafa inset; }
.scroller-row.even { background: #e2e2e2; box-shadow: 0 1px 0 #fafafa inset; border-bottom: 1px solid #eee;}
.scroller-row:hover { background: rgba(0,0,0,.2); }
.scroller-row .dataColumn { display: inline-block; border-left: 1px solid #dfdfdf; padding: 7px 11px; height: 29px; overflow: hidden; }
.vue-recycle-scroller__item-view { border-top: 1px solid #cccbcb; box-shadow: 0 1px 0 #fafafa inset; display: inline-block !important; }
.vue-recycle-scroller__item-wrapper { overflow: initial !important; } 
.scroller.usePixel .vue-recycle-scroller__item-view { width: auto !important; }

.usePixel .scroller-row { width: auto; }

.virtual-list { overflow-y: scroll !important; }

.tableHeader { overflow-x: hidden; overflow-y: scroll; z-index: 100000; font-size: 11px; height: 61px; white-space: nowrap; }
.tableHeader .dataColumn { 
  display: inline-block; 
  border-left: 1px solid #dfdfdf; 
  padding: 7px 11px; overflow: hidden; 
  text-align: left; 
  background: #eee; 
  color: #909090; 
  border-left: 1px solid #dfdfdf; 
  white-space: nowrap; 
  height: 100%;
  vertical-align: top;
}
.tableHeader .dataColumn input, .tableHeader .dataColumn select { width: 100%; height: 30px; display: inline-block; }
.tableHeader .dataColumn .datepicker input { width: 45%; margin-right: 3%; min-width: 60px; }
.tableHeader .dataColumn.hasFilter { cursor: pointer; }
.tableHeader .dataColumn label { white-space: nowrap; display: block; }

/* V-context */
.v-context,.v-context ul{background-color:#fff;background-clip:padding-box;border-radius:.25rem;border:1px solid rgba(0,0,0,.15);-webkit-box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);display:block;margin:0;padding:10px 0;min-width:10rem;z-index:1500;position:fixed;list-style:none;-webkit-box-sizing:border-box;box-sizing:border-box;max-height:calc(100% - 50px);overflow-y:auto}
.v-context { padding: 0; box-shadow: none; border: 0;}
.v-context>li,.v-context ul>li{margin:0;position:relative}.v-context>li>a,.v-context ul>li>a{display:block;padding:.5rem 1.5rem;font-weight:400;color:#212529;text-decoration:none;white-space:nowrap;background-color:transparent;border:0}
.v-context>li>a:focus,.v-context>li>a:hover,.v-context ul>li>a:focus,.v-context ul>li>a:hover{text-decoration:none;color:#212529;background-color:#f8f9fa}
.v-context:focus,.v-context>li>a:focus,.v-context ul:focus,.v-context ul>li>a:focus{outline:0}.v-context__sub>a:after{content:"\2BC8";float:right;padding-left:1rem}
.v-context__sub>ul{display:none}
.v-context ul {
  list-style: none;
  padding: 10px 0;
  margin: 10px 0;
  font-size: 12px;
  font-weight: 600;
  background: #fafafa;
  border: 1px solid #bdbdbd;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  display: block;
  padding: 0;
  position: fixed;
  width: 250px;
  z-index: 99999;
}
.v-context ul li {
  margin: 0;
  padding: 10px 35px;
  cursor: pointer;
}
.v-context ul li:hover {
  background: #1e88e5;
  color: #fafafa;
}
</style>